module.exports = "https://img.zhijierongxing.com/saas/img/mine_menu7.20e07016.png";